import { render } from "./dashboard-okr-board.vue?vue&type=template&id=c280c98e&scoped=true"
import script from "./dashboard-okr-board.vue?vue&type=script&lang=js"
export * from "./dashboard-okr-board.vue?vue&type=script&lang=js"

import "./dashboard-okr-board.vue?vue&type=style&index=0&id=c280c98e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c280c98e"]])

export default __exports__